import { useState } from "react";

import { reactQueryPost } from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

export const useCommunityMemberSearch = () => {
  const [communityMembers, setCommunityMembers] = useState([]);

  const searchCommunityMembers = ({
    query = "",
    filters = {},
    fields = "name_and_email",
    ...rest
  }) =>
    reactQueryPost(
      internalApi.search.communityMembers.index({
        params: {
          query_type: fields,
          query,
          ...rest,
        },
      }),
      {
        filters,
      },
    ).then(data => {
      setCommunityMembers(data.records);
    });

  const resetCommunityMembers = () => {
    setCommunityMembers([]);
  };
  return {
    searchCommunityMembers,
    communityMembers,
    resetCommunityMembers,
  };
};
